(function ($) {
  $(function () {
    //document.ready
    $('.accordion__button').click(function (event) {
      event.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
      event.stopPropagation();
    });
  });
})(jQuery);